// ESTIKA Skincare — front-end interactivity
document.addEventListener('DOMContentLoaded', () => {
  // Accordion (PDP)
  document.querySelectorAll('[data-accordion-toggle]').forEach((header) => {
    header.addEventListener('click', () => {
      const item = header.closest('.accordion-item')
      const body = item && item.querySelector('.accordion-body')
      if (!item || !body) return
      const isOpen = item.classList.contains('open')
      const accordion = header.closest('.accordion')
      if (accordion) {
        accordion.querySelectorAll('.accordion-item.open').forEach((otherItem) => {
          if (otherItem !== item) otherItem.classList.remove('open')
        })
      }
      item.classList.toggle('open', !isOpen)
    })
  })

  // Protocol tabs
  const tabs = document.querySelectorAll('[data-protocol-tab]')
  const panels = document.querySelectorAll('[data-protocol-panel]')
  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = tab.getAttribute('data-protocol-tab')
      tabs.forEach((t) => t.classList.remove('active'))
      panels.forEach((p) => p.classList.remove('active'))
      tab.classList.add('active')
      const panel = document.querySelector(`[data-protocol-panel="${target}"]`)
      if (panel) panel.classList.add('active')
    })
  })

  // Quantity selector on PDP (syncs hidden qty input used by the Add To Bag form)
  document.querySelectorAll('.pdp-actions .qty-selector').forEach((qtySelector) => {
    const span = qtySelector.querySelector('span')
    const [minusBtn, plusBtn] = qtySelector.querySelectorAll('button')
    const hiddenQty = document.getElementById('pdp-qty-input')
    let qty = 1
    const sync = () => {
      if (span) span.textContent = qty
      if (hiddenQty) hiddenQty.value = qty
    }
    minusBtn && minusBtn.addEventListener('click', () => { qty = Math.max(1, qty - 1); sync() })
    plusBtn && plusBtn.addEventListener('click', () => { qty += 1; sync() })
  })

  // Quantity selectors on the Cart page (update the real Shopify cart)
  document.querySelectorAll('.cart-qty-cell .qty-selector').forEach((qtySelector) => {
    const input = qtySelector.querySelector('input[type="number"]')
    const [minusBtn, plusBtn] = qtySelector.querySelectorAll('button')
    const form = qtySelector.closest('form')
    const submitForm = () => {
      if (!form) return
      if (form.requestSubmit) { form.requestSubmit() } else { form.submit() }
    }
    minusBtn && minusBtn.addEventListener('click', () => {
      input.value = Math.max(0, (parseInt(input.value, 10) || 1) - 1)
      submitForm()
    })
    plusBtn && plusBtn.addEventListener('click', () => {
      input.value = (parseInt(input.value, 10) || 0) + 1
      submitForm()
    })
    input && input.addEventListener('change', submitForm)
  })

  // PDP Photo Gallery (horizontal scroll + thumbnail sync)
  document.querySelectorAll('.pdp-gallery').forEach((gallery) => {
    const track = gallery.querySelector('.pdp-gallery-main')
    const thumbs = gallery.querySelectorAll('[data-pdp-thumb]')
    if (!track) return

    const goToSlide = (index) => {
      const slide = track.children[index]
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' })
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = parseInt(thumb.getAttribute('data-index'), 10) || 0
        goToSlide(index)
      })
    })

    if (thumbs.length) {
      let scrollTimeout
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout)
        scrollTimeout = setTimeout(() => {
          const slides = Array.from(track.children)
          let closestIndex = 0
          let closestDistance = Infinity
          slides.forEach((slide, i) => {
            const distance = Math.abs(slide.offsetLeft - track.scrollLeft)
            if (distance < closestDistance) { closestDistance = distance; closestIndex = i }
          })
          thumbs.forEach((t, i) => t.classList.toggle('active', i === closestIndex))
        }, 100)
      })
    }
  })

  // Shop-all filter chips (client-side tag filtering, no page reload)
  document.querySelectorAll('[data-filter-bar]').forEach((bar) => {
    const grid = bar.parentElement.querySelector('[data-product-grid]')
    if (!grid) return
    const cards = grid.querySelectorAll('.product-card')
    bar.querySelectorAll('.filter-chip').forEach((chip) => {
      chip.addEventListener('click', () => {
        bar.querySelectorAll('.filter-chip').forEach((c) => c.classList.remove('active'))
        chip.classList.add('active')
        const filter = (chip.getAttribute('data-filter') || 'all').toLowerCase()
        cards.forEach((card) => {
          if (filter === 'all') {
            card.style.display = ''
            return
          }
          const tags = card.getAttribute('data-tags') || ''
          card.style.display = tags.includes(filter) ? '' : 'none'
        })
      })
    })
  })

  // Mobile nav toggle
  const navToggle = document.querySelector('[data-nav-toggle]')
  const mainNav = document.querySelector('.main-nav')
  if (navToggle && mainNav) {
    navToggle.addEventListener('click', () => {
      mainNav.classList.toggle('nav-open')
    })
  }
})
